export default "__VITE_ASSET__C8Wen1tk__"